export const INSIGHTS_SECTION_TITLE = "activation.home.insights.title";

export const INSIGHTS_SECTION_SUBTITLE = "activation.home.insights.subtitle";

export const INSIGHTS_LOADING_ROTATION_1 = "activation.home.insights.loading_rotation_1";

export const INSIGHTS_LOADING_ROTATION_2 = "activation.home.insights.loading_rotation_2";

export const INSIGHTS_LOADING_ROTATION_3 = "activation.home.insights.loading_rotation_3";

export const INSIGHTS_LOADING_ROTATION_4 = "activation.home.insights.loading_rotation_4";

export const INSIGHTS_LOADING_ROTATION_KEYS = [
    INSIGHTS_LOADING_ROTATION_1,
    INSIGHTS_LOADING_ROTATION_2,
    INSIGHTS_LOADING_ROTATION_3,
    INSIGHTS_LOADING_ROTATION_4,
] as const;

export const INSIGHTS_SUGGESTIONS_SECTION_LABEL = "activation.home.insights.body.suggestions";

export const INSIGHTS_FEEDBACK_COPY = "activation.home.insights.feedback.copy";

export const INSIGHTS_FEEDBACK_COPIED = "activation.home.insights.feedback.copied";

export const INSIGHTS_FEEDBACK_COPY_FAILED = "activation.home.insights.feedback.copy_failed";

export const INSIGHTS_FEEDBACK_THUMBS_UP = "activation.home.insights.feedback.thumbs_up";

export const INSIGHTS_FEEDBACK_THUMBS_DOWN = "activation.home.insights.feedback.thumbs_down";

export const INSIGHTS_FEEDBACK_MODAL_TITLE = "activation.home.insights.feedback.modal_title";

export const INSIGHTS_FEEDBACK_MODAL_PLACEHOLDER = "activation.home.insights.feedback.modal_placeholder";

export const INSIGHTS_FEEDBACK_MODAL_CANCEL = "activation.home.insights.feedback.modal_cancel";

export const INSIGHTS_FEEDBACK_MODAL_SUBMIT = "activation.home.insights.feedback.modal_submit";
